module.exports = __webpack_public_path__ + "img/112.8fa468f0.jpg";